import { MARKERS, MARKER_STATUS } from "../constants";
export const DND_LAYER_FIELD = 'layer-row';

const LAYER_TYPES = [
    {value: 'symbol', label: I18n.t('symbol')},
    {value: 'circle', label: I18n.t('circle')},
    {value: 'heatmap', label: I18n.t('heatmap')},
    {value: 'raster', label: I18n.t('raster')},
    {value: 'customSmartmeIcon', label: I18n.t('smartme_icon')}
]

const PAINT_SUPPORT_FEATURE = {
    featureState: "featureState",
    interpolate: "interpolate"
}

export const LAYER_PROPS = {
    source: {
        title: I18n.t("source"),
        type: "enum",
        description: I18n.t('mapbox_layer_source'),
        optional: false,
    },
    type: {
        title: I18n.t("type"),
        description: I18n.t('mapbox_layer_type'),
        options: LAYER_TYPES,
        type: "enum",
        optional: false
    },
    layerGroup: {
        title: I18n.t("overlay_group"),
        description: I18n.t('mapbox_layer_group'),
        type: "string",
        default: "",
        optional: true
    },
    layerName: {
        title: I18n.t("name"),
        description: I18n.t('mapbox_layer_name'),
        type: "string",
        optional: true
    },
    layerDefault: {
        title: I18n.t("drawn_by_default"),
        description: "When layer is in a group, it's shown by default when the group is selected",
        type: "string",
        optional: true
    },
    layerVisibility: {
        type: "boolean",
        description: I18n.t('mapbox_layer_visible_override'),
        title: I18n.t('visibility')
    },
    advancedSetting: {
        type: "json",
        description: I18n.t('mapbox_custom_settings'),
        title: I18n.t('advanced_settings')
    },
    circle: {
        layout: {
            'visibility':{
                default: "visible",
                type: "enum",
                options: ["visible", "none"],
                optional: true,
                description: I18n.t('mapbox_layer_visible'),
                title: I18n.t('visibility')
            }
        },
        paint: {
            'circle-color': {
                default: "#000000",
                support: [PAINT_SUPPORT_FEATURE.featureState, PAINT_SUPPORT_FEATURE.interpolate],
                type: "color",
                optional: true,
                description: I18n.t('mapbox_circle_color'),
                title: I18n.t('color')
            },
            'circle-radius': {
                default: 5,
                support: [PAINT_SUPPORT_FEATURE.featureState, PAINT_SUPPORT_FEATURE.interpolate],
                type: "number",
                min: 0,
                optional: true,
                description: I18n.t('mapbox_circle_radius'),
                title: I18n.t('radius')
            }
        }
    },
    heatmap: {
        layout: {
            'visibility':{
                default: "visible",
                type: "enum",
                options: ["visible", "none"],
                optional: true,
                description: I18n.t('mapbox_layer_visible'),
                title: I18n.t('visibility')
            }
        },
        paint: {
            'heatmap-color': {
                defaultJson: ["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"royalblue",0.3,"cyan",0.5,"lime",0.7,"yellow",1,"red"],
                default: "#000000",
                support: [PAINT_SUPPORT_FEATURE.featureState, PAINT_SUPPORT_FEATURE.interpolate],
                type: "color",
                dependsOn: [],
                optional: false,
                description: I18n.t('mapbox_heatmap_color'),
                title: I18n.t('color')
            },
            'heatmap-radius': {
                default: 1,
                support: [PAINT_SUPPORT_FEATURE.featureState, PAINT_SUPPORT_FEATURE.interpolate],
                type: "number",
                min: 0,
                optional: true,
                description: I18n.t('mapbox_heatmap_radius'),
                title: I18n.t('radius')
            }
        }
    },
    symbol: {
        layout: {
            'text-field': {
                default: "",
                type: "string", //In docs is "formatted" type
                optional: true,
                description: I18n.t('mapbox_text_field'),
                title: I18n.t('text_field')
            },
            'visibility':{
                default: "visible",
                type: "enum",
                options: ["visible", "none"],
                optional: true,
                description: I18n.t('mapbox_layer_visible'),
                title: I18n.t('visibility')
            }
        },
        paint: {
            'text-color': {
                default: "#000000",
                support: [PAINT_SUPPORT_FEATURE.featureState, PAINT_SUPPORT_FEATURE.interpolate],
                type: "color",
                dependsOn: ["text-field"],
                optional: true,
                description: I18n.t('mapbox_circle_color'),
                title: I18n.t('color')
            }
        }
    },
    raster: {
        layout: {
            'visibility':{
                default: "visible",
                type: "enum",
                options: ["visible", "none"],
                optional: true,
                description: I18n.t('mapbox_layer_visible'),
                title: I18n.t('visibility')
            }
        }
    },
    customSmartmeIcon: {
        layout: {
            "type": {
                type: "enum",
                options: Object.keys(MARKERS).map((s) => ({value: s, label: s})),
                description: I18n.t('mapbox_icon_type'),
                title: I18n.t('type')
            },
            "status": {
                type: "enum",
                options: Object.keys(MARKER_STATUS).map((s) => ({value: s, label: s})),
                description: I18n.t('mapbox_icon_status'),
                title: I18n.t('status')
            },
            "info1": {
                type: 'string',
                description: I18n.t('mapbox_cluster_info'),
                title: I18n.t('info') + 1
            },
            "unit": {
                type: 'string',
                description: I18n.t('mapbox_cluster_info_unit'),
                title: I18n.t('unit')
            },
            "info2": {
                type: 'string',
                title: I18n.t('info') + 2,
                description: I18n.t('mapbox_point_info_middle_right')
            },
            "info3": {
                type: 'string',
                title: I18n.t('info') + 3,
                description: I18n.t('mapbox_point_info_bottom_right')
            }
        }
    }
};
